import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NavigationList } from "@sprout/list-navigation";
import { useCallback, useMemo } from "react";
import { Link, useHistory } from "react-router-dom";
import { Button } from "sprout-ui-dom/dist/Button";
import styled, { css } from "styled-components";
const TopicPageSectionPostsSeeMoreButton = styled(Button)`
  margin: 10px 0;

  ${({ $isActive  })=>$isActive && css`
      background: rgba(25, 118, 210, 0.12);
    `}
`;
const TopicPageSectionPostsSeeMore = (props)=>{
    const { sectionURL , totalPostsCount , sectionId  } = props;
    const history = useHistory();
    const handleSingularAction = useCallback((command)=>{
        if (command === "OPEN") {
            history.push(sectionURL);
            return true;
        }
        return false;
    }, [
        history,
        sectionURL
    ]);
    const [items, actions] = useMemo(()=>[
            [
                {
                    __typename: "__Placeholder",
                    id: "more",
                    nodeId: "__Placeholder|more"
                }, 
            ],
            [
                "OPEN"
            ], 
        ], []);
    return /*#__PURE__*/ _jsx(NavigationList, {
        listId: `TopicPageSectionPostsMore|${sectionId}`,
        actions: actions,
        performSingularAction: handleSingularAction,
        items: items,
        renderItem: (_item, _index, navigationItemHelpers)=>/*#__PURE__*/ _jsxs(TopicPageSectionPostsSeeMoreButton, {
                as: Link,
                to: sectionURL,
                variant: "outline",
                height: "32px",
                $isActive: navigationItemHelpers.isActive,
                children: [
                    "See all ",
                    totalPostsCount
                ]
            })
    });
};
export default TopicPageSectionPostsSeeMore;
